(function() {
  if ('IntersectionObserver' in window) {
    const videoContainers = document.querySelectorAll('[data-video-lazy-load]');
    
    if (videoContainers.length > 0) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const container = entry.target;
            const video = container.querySelector('video[data-lazy-video]');
            
            if (video && !video.dataset.loaded) {
              video.dataset.loaded = 'true';
              
              video.load();
              
              video.addEventListener('loadeddata', () => {
                video.play().catch(err => {
                  console.warn('Video autoplay failed:', err);
                });
              }, { once: true });
              
              observer.unobserve(container);
            }
          }
        });
      }, {
        rootMargin: '50%',
        threshold: 0.1
      });
      
      videoContainers.forEach(container => {
        videoObserver.observe(container);
      });
    }
  } else {
    const videoContainers = document.querySelectorAll('[data-video-lazy-load]');
    videoContainers.forEach(container => {
      const video = container.querySelector('video[data-lazy-video]');
      if (video) {
        video.load();
        video.play().catch(err => {
          console.warn('Video autoplay failed:', err);
        });
      }
    });
  }
})();
//  {% comment %} custom script by Vlad Zinchenko for bonus wallet {% endcomment %}
(function () {
  if (window.__pikoreFreeWalletScriptLoaded) return;
  if (!window.PikoreFreeWallet || typeof window.PikoreFreeWallet.createEngine !== 'function') return;
  window.__pikoreFreeWalletScriptLoaded = true;

  const GIFT_PRODUCT_HANDLE = 'bonus-leather-wallet-limited-offer';
  const GIFT_VARIANT_ID = 49726922916182;
  const MIN_AMOUNT = 50;
  const CHECK_DEBOUNCE_MS = 140;
  const INTERNAL_HOOK_SUPPRESS_MS = 1600;

  const STORE_CURRENCY =
    (window.Shopify && Shopify.currency && Shopify.currency.shop_currency)
      ? Shopify.currency.shop_currency
      : 'USD';

  const engine = window.PikoreFreeWallet.createEngine({
    giftVariantId: GIFT_VARIANT_ID,
    giftProductHandle: GIFT_PRODUCT_HANDLE,
    minAmount: MIN_AMOUNT,
    storeCurrency: STORE_CURRENCY,
    bonusTitleKeyword: 'Bonus Leather Wallet'
  }, {
    getActiveCurrency: function () {
      return window.Shopify && Shopify.currency ? Shopify.currency.active : STORE_CURRENCY;
    },
    getShopCurrency: function () {
      return window.Shopify && Shopify.currency ? Shopify.currency.shop_currency : STORE_CURRENCY;
    },
    getCurrencyRate: function () {
      return window.Shopify && Shopify.currency ? Shopify.currency.rate : null;
    },
    convertCurrency: function (amount, from, to) {
      if (window.Currency && typeof window.Currency.convert === 'function') {
        return window.Currency.convert(amount, from, to);
      }
      return amount;
    }
  });
  const BONUS_TITLE_KEYWORD = 'Bonus Leather Wallet';
  const BONUS_PRODUCT_URL = 'https://pikore.shop/products/leather-wallet-1';
  const BONUS_EVERY_PURCHASE_TEXT = 'every purchase';

  const WARNING_TEXT = 'Warning: Gift cards must be purchased separately';
  const WARNING_NODE_CLASS = 'pikore-giftcard-warning';
  const MIX_CLASS = 'pikore-giftcard-mix';
  const BONUS_ROW_CLASS = 'pikore-bonus-wallet-row';
  const GIFTCARD_ROW_CLASS = 'pikore-giftcard-row';

  let cartRunning = false;
  let checkTimer = null;
  let cartSig = '';
  let mutateLock = false;
  let giftAddInFlight = false;
  let suppressHookUntil = 0;
  let uiQueued = false;
  let domObserverBound = false;

  function ensureStyle() {
    if (document.getElementById('pikore-free-wallet-style')) return;
    const s = document.createElement('style');
    s.id = 'pikore-free-wallet-style';
    s.textContent = `
      .${BONUS_ROW_CLASS} .cart__items__remove,
      .${BONUS_ROW_CLASS} .cart__items__quantity { display:none !important; }

      .${BONUS_ROW_CLASS} .cart__items__title p a,
      .${BONUS_ROW_CLASS} .cart__items__image a { pointer-events:auto !important; }

      .${WARNING_NODE_CLASS} { margin-top:6px; display:none; }
      .${WARNING_NODE_CLASS} .item__total__savings { color:#c0392b; display:block; }

      html.${MIX_CLASS} .${GIFTCARD_ROW_CLASS} .${WARNING_NODE_CLASS} { display:block; }
    `;
    document.head.appendChild(s);
  }

  function rowTitleLink(row) {
    return row.querySelector('.cart__items__title p a');
  }

  function isBonusRow(row) {
    const a = rowTitleLink(row);
    return !!(a && (a.textContent || '').includes(BONUS_TITLE_KEYWORD));
  }

  function isGiftCardRow(row) {
    const a = rowTitleLink(row);
    const href = a && a.getAttribute ? (a.getAttribute('href') || '') : '';
    const t = (row.textContent || '').toLowerCase();
    return t.includes('gift card') || href.includes('gift-card');
  }

  function ensureGiftCardWarningNode(row) {
    const titleCol = row.querySelector('.cart__items__title');
    if (!titleCol) return null;

    let node = titleCol.querySelector('.' + WARNING_NODE_CLASS);
    if (node) return node;

    node = document.createElement('div');
    node.className = WARNING_NODE_CLASS;

    const inner = document.createElement('span');
    inner.className = 'item__total__savings';
    inner.innerHTML = '<strong>' + WARNING_TEXT + '</strong>';
    node.appendChild(inner);

    const meta = titleCol.querySelector('.cart__items__meta');
    if (meta && meta.parentNode === titleCol) {
      meta.insertAdjacentElement('afterend', node);
    } else {
      const seeDetails = titleCol.querySelector('.see-details');
      if (seeDetails) seeDetails.insertAdjacentElement('afterend', node);
      else titleCol.appendChild(node);
    }

    return node;
  }

  function hideBonusPromoLine(row) {
    const nodes = row.querySelectorAll('*');
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      if (!node || node.children.length) continue;
      const text = (node.textContent || '').trim().toLowerCase();
      if (!text || !text.includes(BONUS_EVERY_PURCHASE_TEXT)) continue;
      node.style.display = 'none';
    }
  }

  function setMixedUI(on) {
    document.documentElement.classList.toggle(MIX_CLASS, !!on);
  }

  function applyUI() {
    ensureStyle();

    const rows = document.querySelectorAll('.cart__items__row');
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];

      const bonus = isBonusRow(row);
      const gc = isGiftCardRow(row);

      row.classList.toggle(BONUS_ROW_CLASS, bonus);
      row.classList.toggle(GIFTCARD_ROW_CLASS, gc);

      if (bonus) {
        const a = rowTitleLink(row);
        const imgA = row.querySelector('.cart__items__image a');
        if (a) a.href = BONUS_PRODUCT_URL;
        if (imgA) imgA.href = BONUS_PRODUCT_URL;
        hideBonusPromoLine(row);
      }

      if (gc) ensureGiftCardWarningNode(row);
    }
  }

  function queueUI() {
    if (uiQueued) return;
    uiQueued = true;
    requestAnimationFrame(() => {
      uiQueued = false;
      applyUI();
    });
  }

  function isCartPage() {
    return (window.location.pathname || '').startsWith('/cart');
  }

  function beginInternalCartWork() {
    suppressHookUntil = Date.now() + INTERNAL_HOOK_SUPPRESS_MS;
  }

  function externalHooksAllowed() {
    return Date.now() >= suppressHookUntil;
  }

  function isCartMutationUrl(url) {
    return engine.isCartMutationUrl(url);
  }

  function notifyCartUpdated() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  function signature(cart) {
    return engine.signature(cart);
  }

  function analyzeCart(cart) {
    return engine.analyzeCart(cart);
  }

  async function postCartUpdate(updates) {
    if (!updates || !Object.keys(updates).length) return true;
    beginInternalCartWork();
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
      credentials: 'same-origin'
    });
    return res.ok;
  }

  async function normalizeWalletLines(cart) {
    const updates = engine.buildNormalizeUpdates(engine.getWalletLines(cart && cart.items));
    if (!updates) return true;
    return postCartUpdate(updates);
  }

  async function removeAllWallets(cart) {
    const updates = engine.buildRemoveUpdates(engine.getWalletLines(cart && cart.items));
    if (!updates) return true;
    return postCartUpdate(updates);
  }

  async function addGiftOnce() {
    if (giftAddInFlight) return false;
    giftAddInFlight = true;
    beginInternalCartWork();

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }),
        credentials: 'same-origin'
      });

      if (!res.ok) return false;

      const cart = await getCart();
      const walletLines = engine.getWalletLines(cart.items);

      if (!walletLines.length) return false;

      const walletQty = walletLines.reduce((sum, line) => sum + (Number(line.quantity) || 0), 0);
      if (walletQty > 1 || walletLines.length > 1) {
        return normalizeWalletLines(cart);
      }

      return true;
    } finally {
      giftAddInFlight = false;
    }
  }

  async function finishMutation(ok) {
    if (!ok) {
      mutateLock = false;
      return;
    }

    try {
      const cart = await getCart();
      cartSig = signature(cart);
    } catch (e) {}

    mutateLock = false;

    if (isCartPage()) {
      window.location.reload();
      return;
    }

    notifyCartUpdated();
    queueUI();
  }

  async function checkCartLogic() {
    if (cartRunning || mutateLock) return;
    cartRunning = true;
    beginInternalCartWork();

    try {
      const cart = await getCart();
      const state = analyzeCart(cart);

      setMixedUI(state.hasGiftCard && state.hasNonGiftCard);
      queueUI();

      const action = engine.decideAction(state);

      if (action === engine.ACTION.NONE) {
        cartSig = state.sig;
        return;
      }

      if (action === engine.ACTION.NORMALIZE) {
        mutateLock = true;
        await finishMutation(await normalizeWalletLines(cart));
        return;
      }

      if (action === engine.ACTION.REMOVE) {
        mutateLock = true;
        await finishMutation(await removeAllWallets(cart));
        return;
      }

      if (action === engine.ACTION.ADD) {
        mutateLock = true;
        await finishMutation(await addGiftOnce());
      }
    } catch (e) {
    } finally {
      cartRunning = false;
    }
  }

  function scheduleCartCheck(delay) {
    const wait = typeof delay === 'number' ? delay : CHECK_DEBOUNCE_MS;
    if (checkTimer) clearTimeout(checkTimer);
    checkTimer = setTimeout(() => {
      checkTimer = null;
      checkCartLogic();
    }, wait);
  }

  function hookNetwork() {
    const nativeFetch = window.fetch;

    window.fetch = function () {
      const requestUrl = arguments[0] && arguments[0].toString ? arguments[0].toString() : '';
      const shouldSchedule = isCartMutationUrl(requestUrl) && externalHooksAllowed();
      const response = nativeFetch.apply(this, arguments);

      if (shouldSchedule) {
        response.finally(() => scheduleCartCheck());
      }

      return response;
    };

    const nativeOpen = XMLHttpRequest.prototype.open;
    const nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__pikore_wallet_url = url;
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      const url = (this.__pikore_wallet_url || '').toString();
      if (isCartMutationUrl(url) && externalHooksAllowed()) {
        this.addEventListener('loadend', () => scheduleCartCheck(), { once: true });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  function hookDOM() {
    if (domObserverBound) return;
    const root = document.querySelector('[data-cart-form], cart-drawer, #cart-drawer, #candyrack-slider-cart');
    if (!root) return;

    domObserverBound = true;
    const observer = new MutationObserver(() => {
      queueUI();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    ensureStyle();
    applyUI();
    hookNetwork();
    hookDOM();
    checkCartLogic();
  });

  document.addEventListener('cart:refresh', () => scheduleCartCheck(180));
  document.addEventListener('theme:cart:change', () => scheduleCartCheck(180));
  document.addEventListener('theme:cart:reload', () => scheduleCartCheck(180));
})();


(function () {
  'use strict';

  if (window.__pikoreLinkedAddonsLoaded) return;
  window.__pikoreLinkedAddonsLoaded = true;

  const ROOT = Shopify.routes.root || '/';

  const fetchJSON = async (url, opts = {}) => {
    const res = await fetch(url, {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      ...opts
    });

    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  };

  const normalize = (value) => {
    return (value || '')
      .toString()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  };

  const getForProductValue = (item) => {
    if (!item || !item.properties || typeof item.properties !== 'object') return null;

    return (
      item.properties['For Product'] ||
      item.properties['For product'] ||
      item.properties['For product '] ||
      null
    );
  };

  const getBundleToken = (item) => {
    if (!item || !item.properties || typeof item.properties !== 'object') return '';
    const token = item.properties._bundle_token;
    return token == null ? '' : String(token).trim();
  };

  const getBundleSignature = (item) => {
    if (!item || !item.properties || typeof item.properties !== 'object') return '';
    const signature = item.properties._bundle_signature;
    return signature == null ? '' : String(signature).trim();
  };

  const getMainTitle = (item) => {
    if (!item) return '';

    const base = item.product_title || item.untranslated_product_title || item.title || '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

    return variant ? `${base} - ${variant}` : base;
  };

  const isAddonItem = (item) => {
    const type = normalize(item?.product_type);
    const title = normalize(item?.product_title || item?.title);

    return (
      type === 'personalization' ||
      type === 'add-ons' ||
      type === 'addons' ||
      title.includes('personalization')
    );
  };

  let syncing = false;

  const prepareSections = () => {
    const sections = [];

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections }
      })
    );

    return sections;
  };

  const dispatchCartChange = (cart) => {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'line-item:change',
          cart
        }
      })
    );
  };

  const cleanupLinkedAddons = async () => {
    if (syncing) return;

    syncing = true;

    try {
      const cart = await fetchJSON(`${ROOT}cart.js`);
      const items = cart.items || [];
      const updates = {};

      const mainItems = items.filter((item) => !isAddonItem(item));
      const addonItems = items.filter((item) => isAddonItem(item));
      const mainQtyByToken = new Map();
      const mainQtyBySignature = new Map();

      mainItems.forEach((item) => {
        const token = getBundleToken(item);
        const qty = Number(item.quantity) || 0;
        if (token) {
          mainQtyByToken.set(token, (mainQtyByToken.get(token) || 0) + qty);
        }
        const signature = getBundleSignature(item);
        if (signature) {
          mainQtyBySignature.set(signature, (mainQtyBySignature.get(signature) || 0) + qty);
        }
      });

      addonItems.forEach((addon) => {
        const token = getBundleToken(addon);
        if (token) {
          const totalMainQty = mainQtyByToken.get(token) || 0;

          if (totalMainQty <= 0) {
            updates[addon.key] = 0;
          }
          return;
        }

        const signature = getBundleSignature(addon);
        if (signature) {
          const totalMainBySignature = mainQtyBySignature.get(signature) || 0;
          if (totalMainBySignature <= 0) updates[addon.key] = 0;
          return;
        }

        const forProduct = normalize(getForProductValue(addon));
        if (!forProduct) return;

        const matchedMainItems = mainItems.filter((item) => normalize(getMainTitle(item)) === forProduct);
        if (matchedMainItems.length === 0) updates[addon.key] = 0;
      });

      if (!Object.keys(updates).length) return;

      const sections = prepareSections();

      const updatedCart = await fetchJSON(`${ROOT}cart/update.js`, {
        method: 'POST',
        body: JSON.stringify({
          updates,
          sections: sections.join(',')
        })
      });

      dispatchCartChange(updatedCart);

      if (window.location.pathname === '/cart') {
        window.location.reload();
      }

      return updatedCart;
    } finally {
      syncing = false;
    }
  };

  document.addEventListener('cart:change', function () {
    setTimeout(cleanupLinkedAddons, 150);
  });

  document.addEventListener('cart:refresh', function () {
    setTimeout(cleanupLinkedAddons, 150);
  });

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(cleanupLinkedAddons, 400);
  });

  window.addEventListener('pageshow', function () {
    setTimeout(cleanupLinkedAddons, 400);
  });

  const originalFetch = window.fetch;

  window.fetch = async function () {
    const response = await originalFetch.apply(this, arguments);

    try {
      const url = typeof arguments[0] === 'string' ? arguments[0] : arguments[0]?.url || '';

      if (
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/add')
      ) {
        setTimeout(cleanupLinkedAddons, 250);
      }
    } catch (error) {}

    return response;
  };
})();

(function () {
  if (window.__pikoreCandyrackOrderNoteLoaded) return;
  window.__pikoreCandyrackOrderNoteLoaded = true;

  const ROOT = Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  const ROOT_SELECTOR = '#candyrack-slider-cart';
  const BODY_SELECTOR = '.candyrack-slider-cart-custom-block-body';
  const TOOLS_SELECTOR = '[data-pikore-cr-tools]';
  const ITEM_SELECTOR = '.candyrack-slider-cart-item-container';
  let saveTimer = null;
  let saving = false;
  let queuedValue = null;
  let reordering = false;

  function norm(value) {
    return (value || '').toString().toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function getCandyrackRowTitle(row) {
    var titleNode =
      row.querySelector('.candyrack-slider-cart-item-product-details-title') ||
      row.querySelector('.candyrack-slider-cart-item-title') ||
      row.querySelector('a[href*="/products/"]');
    var text = titleNode ? titleNode.textContent : '';
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function isCandyrackAddonRow(row) {
    var link = row.querySelector('a[href*="/products/"]');
    var href = link ? (link.getAttribute('href') || '') : '';
    if (href.indexOf('/products/option-set-') !== -1) return true;
    return norm(row.textContent).indexOf('personalization option') !== -1;
  }

  function extractForProductFromRow(row) {
    var text = (row.textContent || '').replace(/\s+/g, ' ').trim();
    var m = text.match(/for product\s*:\s*([^:]+?)\s+(?:type\s*:|text\s*:|$)/i);
    if (m && m[1]) return m[1].trim();
    var m2 = text.match(/for product\s*:\s*(.+)$/i);
    return m2 && m2[1] ? m2[1].trim() : '';
  }

  function buildMainQueues(rows) {
    var map = new Map();

    rows.forEach(function (row) {
      if (isCandyrackAddonRow(row)) return;
      var full = getCandyrackRowTitle(row);
      if (!full) return;
      var fullKey = norm(full);
      var baseKey = norm(full.split(' - ')[0] || full);
      if (!map.has(fullKey)) map.set(fullKey, []);
      map.get(fullKey).push(row);
      if (!map.has(baseKey)) map.set(baseKey, []);
      map.get(baseKey).push(row);
    });

    return map;
  }

  function reorderCandyrackAddonRows(root) {
    if (!root || reordering) return;

    var list = root.querySelector('.candyrack-slider-cart-items') || root;
    var rows = Array.prototype.slice.call(list.querySelectorAll(ITEM_SELECTOR));
    if (!rows.length) return;

    var addonRows = rows.filter(isCandyrackAddonRow);
    if (!addonRows.length) return;

    var queues = buildMainQueues(rows);
    var tails = new Map();
    var moved = false;
    reordering = true;

    try {
      addonRows.forEach(function (addonRow) {
        var forProduct = extractForProductFromRow(addonRow);
        if (!forProduct) return;

        var keyFull = norm(forProduct);
        var keyBase = norm((forProduct.split(' - ')[0] || forProduct).trim());
        var mainQueue = queues.get(keyFull) || queues.get(keyBase) || [];
        if (!mainQueue.length) return;

        var mainRow = mainQueue.shift();
        if (!mainRow || !mainRow.parentNode) return;

        var anchor = tails.get(mainRow) || mainRow;
        var parent = anchor.parentNode;
        if (!parent) return;
        if (anchor.nextElementSibling === addonRow) {
          tails.set(mainRow, addonRow);
          return;
        }

        parent.insertBefore(addonRow, anchor.nextElementSibling);
        tails.set(mainRow, addonRow);
        moved = true;
      });
    } finally {
      reordering = false;
    }

    return moved;
  }

  function hideCandyrackBonusPromoLine(root) {
    if (!root) return;
    var bonusRows = root.querySelectorAll(ITEM_SELECTOR + ':has(a[href*="/products/bonus-leather-wallet-limited-offer"])');
    bonusRows.forEach(function (row) {
      row.querySelectorAll('*').forEach(function (node) {
        if (!node || node.children.length) return;
        var text = (node.textContent || '').trim().toLowerCase();
        if (!text || text.indexOf('every purchase') === -1) return;
        node.style.display = 'none';
      });
    });
  }

  function fetchCartNote() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) { return (cart && typeof cart.note === 'string') ? cart.note : ''; })
      .catch(function () { return ''; });
  }

  function saveCartNote(value) {
    if (saving) {
      queuedValue = value;
      return Promise.resolve();
    }

    saving = true;
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ note: value })
    }).catch(function () {})
      .finally(function () {
        saving = false;
        if (queuedValue !== null) {
          var next = queuedValue;
          queuedValue = null;
          saveCartNote(next);
        }
      });
  }

  function setExpanded(section, expanded) {
    var btn = section.querySelector('[data-pikore-cr-toggle]');
    var panel = section.querySelector('[data-pikore-cr-panel]');
    var sign = section.querySelector('[data-pikore-cr-sign]');
    if (!btn || !panel || !sign) return;
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    panel.hidden = !expanded;
    sign.textContent = expanded ? '−' : '+';
  }

  function wireToggle(section) {
    var btn = section.querySelector('[data-pikore-cr-toggle]');
    if (!btn || btn.getAttribute('data-pikore-cr-bound') === 'true') return;
    btn.setAttribute('data-pikore-cr-bound', 'true');
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      setExpanded(section, !expanded);
    });
  }

  function buildTools() {
    var tools = document.createElement('div');
    tools.className = 'pikore-cr-tools';
    tools.setAttribute('data-pikore-cr-tools', '');
    tools.innerHTML = '' +
      '<div class="pikore-cr-accordion" data-pikore-cr-note>' +
        '<button type="button" class="pikore-cr-accordion__toggle" data-pikore-cr-toggle aria-expanded="false" aria-controls="pikore-cr-note-panel">' +
          '<span>Add order note</span>' +
          '<span data-pikore-cr-sign>+</span>' +
        '</button>' +
        '<div class="pikore-cr-accordion__panel" data-pikore-cr-panel id="pikore-cr-note-panel" hidden>' +
          '<label class="pikore-cr-order-note__label" for="pikore-cr-order-note-input">Order note</label>' +
          '<textarea id="pikore-cr-order-note-input" class="pikore-cr-order-note__textarea" placeholder="How can we help you?" data-pikore-order-note-input></textarea>' +
        '</div>' +
      '</div>' +
      '<div class="pikore-cr-accordion" data-pikore-cr-discount>' +
        '<button type="button" class="pikore-cr-accordion__toggle" data-pikore-cr-toggle aria-expanded="false" aria-controls="pikore-cr-discount-panel">' +
          '<span>Discount</span>' +
          '<span data-pikore-cr-sign>+</span>' +
        '</button>' +
        '<div class="pikore-cr-accordion__panel" data-pikore-cr-panel id="pikore-cr-discount-panel" hidden>' +
          '<div data-pikore-discount-slot></div>' +
        '</div>' +
      '</div>';
    return tools;
  }

  function moveDiscountInput(body, tools) {
    var slot = tools.querySelector('[data-pikore-discount-slot]');
    if (!slot) return;
    var coupon = body.querySelector('.docapp-coupon-input.docapp-in-summary');
    if (!coupon) return;
    if (slot.contains(coupon)) return;
    slot.appendChild(coupon);
  }

  function mountTools() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    var body = root.querySelector(BODY_SELECTOR);
    if (!body) return;

    var tools = body.querySelector(TOOLS_SELECTOR);
    if (!tools) {
      tools = buildTools();
      body.insertAdjacentElement('afterbegin', tools);
    }

    var noteSection = tools.querySelector('[data-pikore-cr-note]');
    var discountSection = tools.querySelector('[data-pikore-cr-discount]');
    if (!noteSection || !discountSection) return;

    wireToggle(noteSection);
    wireToggle(discountSection);
    moveDiscountInput(body, tools);
    reorderCandyrackAddonRows(root);
    hideCandyrackBonusPromoLine(root);

    var input = tools.querySelector('[data-pikore-order-note-input]');
    if (input && input.getAttribute('data-pikore-note-bound') !== 'true') {
      input.setAttribute('data-pikore-note-bound', 'true');
      input.addEventListener('input', function () {
        var value = input.value;
        clearTimeout(saveTimer);
        saveTimer = setTimeout(function () {
          saveCartNote(value);
        }, 450);
      });

      fetchCartNote().then(function (note) {
        input.value = note || '';
        setExpanded(noteSection, !!(note && note.trim()));
      });
    }
  }

  function observe() {
    var observer = new MutationObserver(function () {
      mountTools();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    mountTools();
    observe();
  });
})();
